export default "/images/amazon_web_services__upper.png";